import { ApiAuthUser } from "@incendium/api";
import OnboardingAdPlatforms from "features/onboarding/components/OnboardingAdPlatforms";

interface IEcomPlatformOnboardingStep6Props {
  onContinue: () => void;
  onContinueWithInvite?: () => void;
  continueLabel?: string;
  inactiveUsers?: ApiAuthUser[];
}

function EcomPlatformOnboardingStep6({
  onContinue,
  onContinueWithInvite,
  continueLabel,
  inactiveUsers,
}: IEcomPlatformOnboardingStep6Props) {
  return (
    <OnboardingAdPlatforms
      onContinue={onContinue}
      continueLabel={continueLabel}
      onContinueWithInvite={onContinueWithInvite}
      inactiveUsers={inactiveUsers}
    />
  );
}

export default EcomPlatformOnboardingStep6;
